import React,{useState,useEffect,useRef, useContext} from 'react';
import {Container,Row,Col,Form} from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Dashboard/dashboard.css';
import { Link, useHistory,useRouteMatch,useParams} from "react-router-dom";
import { IconBack } from '../../Components/Icons';
import { BoxMetas, CardAgente, CarteraIndividual, CarteraFlotillas ,getAvancesAgentesByClaveOficina, GraficaPeriodo, GraficaPeriodoAgente, TablaAgentesByQuatrimestre, TablaAgentesClaves, TablaLogros, SegmentacionCartera, TablaPolizas, FichaAgente, TablaPolizasAgente, BoxMetas2, TablaReservaPendientesCobertura, TablaReservaPendientesMarca } from '../../Components/Components';
import { MultiSelect } from "react-multi-select-component";
import './Agentes.css';
import { AuthContext } from '../../auth/AuthContext';

export const ViewAgente = ({initState,updateState}) => {

  // GET ID FROM PARAMS
  const {id} = useParams();
  const history = useHistory();
  const ref = useRef(null);

  const { usuario } = useContext(AuthContext);

  const {openMenu, data, loadingData, profileOficinasAgentes} = initState;
  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getFullYear();
  
  const [claves,setClaves] = useState([])
  const [select,setSelected] = useState([])
  const [selectedClaves,setSelectedClaves] = useState([])
  const [datosAgente,setDatosAgente] = useState([])
  const [datosFicha,setDatosFicha] = useState(null);
  const [datosMetas,setDatosMetas] = useState([]);
  const [isSticky, setSticky] = useState(false);
  const [dataAgenteQuatrimestre,setDataAgenteQuatrimestre] = useState([]);
  const [loadDatagraficaTipo,setLoadDatagraficaTipo] = useState(false);
  const [view,setView] = useState('perfil');
  const [loadCarteraIndividual,setLoadCarteraIndividual] = useState(false)
  const [loadCarteraFlotillas,setLoadCarteraFlotillas] = useState(false)
  const [loadAgentesQuatrimestre,setLoadAgentesQuatrimestre] = useState(true)
  const [loadSegmentacionCartera,setLoadSegmentacionCartera] = useState(false)

  const [changeClave,setChangeClave] = useState(false);

  const [dataRpCobertura,setDataRpCobertura] = useState([]);
  const [dataRpMarca,setDataRpMarca] = useState([]);

  //show shadow on sticky header select
  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  useEffect(() => {
    getProfileAgente();
  },[select])

  useEffect(() => { (changeClave) && getAvanceAgente() } ,[changeClave])

  useEffect(() => console.log(usuario),[]);

  useEffect(() => {
    getDesgloseMetaAgente();
    getDatosByIdAgente();
    getAvanceAgente();
  },[])


  return (
    <React.Fragment>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
  
          <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{borderBottom:'1px solid #ccc'}}>
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                <span className="ws_title_header" style={{cursor:'pointer'}} onClick={ (e) => { history.goBack(); }} ><IconBack widht="20px" height="20px" className="pe-2" />Regresar</span>
              </Col>
              <Col className="mb-2" xs={12} md={9}>
                <Row>
                  <Col xs={12} md={4}>
                    <React.Fragment>
                    <h3 className="ws_select_type">Claves</h3>
                      <MultiSelect
                      options={claves}
                      value={select}
                      onChange={(props) => {

                        const newClaves = [];
                        props.map(element => {
                          newClaves.push(element.value);
                        });
                        setSelectedClaves(newClaves)

                        setLoadDatagraficaTipo(true)
                        setLoadCarteraIndividual(true)
                        setLoadCarteraFlotillas(true)
                        setLoadAgentesQuatrimestre(true)
                        setLoadSegmentacionCartera(true)
                        setSelected(props)
                        if(claves.length===props.length){
                          // setSelectedClaves([])
                        }
                        setChangeClave(true);
                      }}
                      labelledBy="Selecciona una clave"
                      overrideStrings={
                        {
                          "allItemsAreSelected": "Se ha seleccionado todo",
                          "clearSearch": "Limpiar Búsqueda",
                          "noOptions": "No hay datos",
                          "search": "Buscar",
                          "selectAll": "Seleccionar todo",
                          "selectAllFiltered": "Seleccionar todo (Filtrado)",
                          "selectSomeItems": "Elegir una clave..."
                        }
                      }
                      hasSelectAll={true}
                    />
                    </React.Fragment>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <Container fluid className="mt-5">
            {
              (view==='perfil') ?
              <React.Fragment>
                <Row>
                  <CardAgente 
                  data={{
                    nombre    : datosAgente.nombre,
                    produccion: datosAgente.cobranza,
                    cargo     : datosAgente.tipo_agente,
                    porcentaje: datosAgente.participacion,
                    foto      : datosAgente.img_perfil,
                    stars     : datosAgente.tipo_agente
                  }} 
                  datosFicha={datosFicha}
                  handleClickPoliza={ (e)=> { setView('poliza') }}  
                  handleClickInsignias={(e)=>{ document.getElementById('tbLogros').scrollIntoView( { behavior: 'smooth' }) }} 
                  handleClickMetas={(e)=>{alert('Agregar Metas')}} 
                  handleClickFichas={(e)=>{ setView('ficha') }}
                  size = { {xs: 12, sm: 12, md: 12, lg: 6, xl: 6, xxl: 6} }
                  />
                  <BoxMetas2 idAgente={id} datosMetas={datosMetas} reload={getDesgloseMetaAgente}/>
                </Row>
                <Row>
                  <GraficaPeriodoAgente 
                  state={initState} 
                  updateState={updateState} 
                  year={currentYear} 
                  selected={currentYear}  
                  loadDatagraficaTipo={loadDatagraficaTipo}
                  setLoadDataGraficaTipo={setLoadDatagraficaTipo}
                  dataSelect={{
                    id_usuario: id,
                    claves: selectedClaves
                  }}
                  size={{xs:12,sm:12,md:12,lg:12}} 
                  />

                  <TablaPolizasAgente initState={initState} updateState={updateState} idAgente={id} />
                     
                  <TablaReservaPendientesCobertura 
                  initState={initState} 
                  updateState={updateState} 
                  data={ dataRpCobertura } 
                  loadData={ loadAgentesQuatrimestre } 
                  size={{xl:6,xxl:6}} 
                  dataSelect={{
                    id: id
                  }}  
                  type="Agente"
                  />

                  <TablaReservaPendientesMarca 
                  initState={initState} 
                  updateState={updateState} 
                  data={ dataRpMarca } 
                  loadData={ loadAgentesQuatrimestre } 
                  size={{xl:6,xxl:6}}
                  dataSelect={{
                    id: id
                  }}  
                  type="Agente"
                  />
                  
                </Row>
                <Row>

                  <TablaAgentesByQuatrimestre 
                  data={ dataAgenteQuatrimestre }
                  loadAgentesQuatrimestre={ loadAgentesQuatrimestre }
                  dataAgente={{ nombre: datosAgente.nombre,id_usuario: id, claves: selectedClaves }}
                  initState={ initState } 
                  updateState={ updateState }  
                  size={{ xs:12,sm:12,md:12,lg:12 }} 
                  />

                  <TablaAgentesClaves 
                  initState={ initState } 
                  updateState={updateState}
                  dataSelect={{
                    id_usuario: id
                  }}  
                  />

                  <SegmentacionCartera 
                  loadSegmentacionCartera={loadSegmentacionCartera}
                  setLoadSegmentacionCartera={setLoadSegmentacionCartera}
                  dataAgente={{
                    id_usuario: id,
                    claves: selectedClaves
                  }}
                  initState={initState} 
                  updateState={updateState}/>
                </Row>
                <Row>
                  <CarteraIndividual
                  loadCarteraIndividual={loadCarteraIndividual}
                  setLoadCarteraIndividual={setLoadCarteraIndividual} 
                  dataAgente={{
                    id_usuario: id,
                    claves: selectedClaves
                  }}
                  initState={initState} 
                  updateState={updateState} 
                  />
                  <CarteraFlotillas
                  loadCarteraFlotillas={loadCarteraFlotillas}
                  setLoadCarteraFlotillas={setLoadCarteraFlotillas}
                  dataAgente={{
                    id_usuario: id,
                    claves: selectedClaves
                  }}
                  initState={initState} 
                  updateState={updateState} 
                  />
                </Row>
                <Row>
                  {/* <TablaLogros initState={initState} updateState={updateState} size={{xs:12,sm:12,md:12,lg:12}}/> */}
                </Row>
              </React.Fragment>
              :  (view==='ficha') ?
              <Row>
                <Col className="mb-2" xs={12} md={3}>
                  <span className="ws_title_header" style={{cursor:'pointer'}} onClick={ (e) => { setView('perfil') }} ><IconBack widht="20px" height="20px" className="pe-2" />Ver perfil</span>
                </Col>
                <FichaAgente 
                nombreAgente={datosAgente.nombre}
                idUsuario={datosAgente.id_usuario}
                initState={initState} 
                updateState={updateState} 
                datosFicha={datosFicha}
                setDatosFicha={setDatosFicha}
                datosAgente={datosAgente}
                setDatosAgente={setDatosAgente}
                />
              </Row>
              :
              <Row>
                <Col className="mb-2" xs={12} md={3}>
                  <span className="ws_title_header" style={{cursor:'pointer'}} onClick={ (e) => { setView('perfil') }} ><IconBack widht="20px" height="20px" className="pe-2" />Ver perfil</span>
                </Col>
                <TablaPolizas initState={initState} updateState={updateState} datosAgente={datosAgente} idAgente={id}/>
              </Row>
            }
          </Container>
        </div>
      </div>
    </React.Fragment>
  )

  function getProfileAgente() {
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getProfileAgente`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        id_usuario:id,
        claves: selectedClaves
      }),
    })
    .then(res => res.json())
    .then((res) => {
      setDatosAgente(res)
      setClaves(makeArrMultiSelect(res.claves))
    })
  }

  function getDatosByIdAgente() {
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getDatosByIdAgente`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        id_usuario:id,
      }),
    })
    .then(res => res.json())
    .then((res) => {
      setDatosFicha(res);
    })
  }

  function getDesgloseMetaAgente(){
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getDesgloseMetaAgente`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        id_usuario:id,
      }),
    })
    .then(res => res.json())
    .then((res) => {
      setDatosMetas(res.list)
    })
  }

  function makeArrMultiSelect(data){
    const newArray = [];
    data.forEach((element,index) => {
      newArray.push({label:element,value:element})
    });
    return newArray;
  }

  function getAvanceAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: id,
      claves: selectedClaves,
    };

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvanceAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setChangeClave(false);
        setLoadAgentesQuatrimestre(false);
        setDataAgenteQuatrimestre(res.list);
        setDataRpCobertura(res.reserva_pendiente_por_cobertura);
        setDataRpMarca(res.reserva_pendiente_por_marca);
      });
  }

  function handleScroll() {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 
  }
}
